import { ThemeProvider } from './src/contexts/theme';
import { GlobalStyle } from './src/styles/global';

export const wrapPageElement = ({ element }) => (
  <>
    <GlobalStyle />
    <ThemeProvider>{element}</ThemeProvider>
  </>
);
